import { useEffect, useState } from "react";
import cropImage from "../../../Utils/cropFace";
import { encrypt } from "../../../Utils/hmac";
import dataURItoBlob from "../../../Utils/dataUriToBlob";
import { uploadFace } from "../../../Services/APIs/scan";
import { useDispatch } from "react-redux";
import { addImages } from "../../../Store/fullScan";

const PreviewFace = (props) => {
    const dispatch = useDispatch()

    const { setImageSide, image, setCamera, setDemo, activeImageSide } = props
    const [updatedImage, setUpdatedImage] = useState(image)
    const [isLoading, setIsLoading] = useState(true)
    const [isPhotoUploading, setPhotoUploading] = useState(false)
    const [isError, setError] = useState("")
    const uid = JSON.parse(localStorage.getItem("usertpi")).usertpi

    useEffect(() => {
        crop()
        setIsLoading(false)
    }, [])

    const upload = async () => {
        try {

            setPhotoUploading(true)
            setError("")

            const data = {
                uid,
                company: JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket,
            }
            const encrypted = encrypt(data)
            const blob = dataURItoBlob(updatedImage)
            const file = new File([blob], "report_image.jpeg", { type: "image/jpeg" });
            const formData = new FormData();
            formData.append("report_image", file);
            formData.append("_n", encrypted);

            await uploadFace({ formData }).then((response) => {
                const report = {
                    title: "Face",
                    data: URL.createObjectURL(blob),
                    file: response.data.data?.fullUrl
                }
                dispatch(addImages(report))
                setImageSide(activeImageSide + 1)
                setDemo(true)
            }).catch(error => {
                setError("Something went wrong")
            }).finally(() => {
                setPhotoUploading(false)
            })
        }
        catch (error) {

        }
    }

    const crop = () => {
        cropImage(image, (croppedDataURI) => {
            if (croppedDataURI) {
                setUpdatedImage(croppedDataURI);
            } else {
                console.error("Cropping failed.");
            }
        });

    }
    return (
        <div className="relative min-h-screen w-full flex flex-col items-center bg-white">
            <div className="flex-1 flex flex-col items-center justify-center w-full pt-6 pb-32">
                {isLoading ? (
                    <p>Please wait...</p>
                ) : (
                    <img
                        src={updatedImage}
                        className="max-h-[60vh] w-auto rounded-3xl object-contain"
                        alt="face"
                    />
                )}
                <p className="text-lg text-red-600 font-semibold my-2">{isError}</p>
            </div>
            <div className="fixed bottom-0 left-0 w-full flex justify-evenly p-5 bg-white z-10 border-t border-gray-200">
                <button
                    className="bg-black text-white font-semibold w-full p-3 me-3 rounded"
                    onClick={() => { setCamera(true) }}>
                    Reshoot
                </button>
                <button
                    className="bg-black text-white font-semibold w-full p-3 rounded"
                    onClick={upload}>
                    {isPhotoUploading ? (
                        <div className="loader-container">
                            <div className="loader"></div>
                        </div>
                    ) : (
                        <span> Next</span>
                    )}
                </button>
            </div>
        </div>
    )
}

export default PreviewFace